import React from 'react';
import Svg, { Path } from 'react-native-svg';
const Check = (props) => (<Svg viewBox="0 0 20 20" fill="none" {...props}>
    <Path d="M16.6663 5L7.49967 14.1667L3.33301 10" stroke={props.color ?? '#3999DE'} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Check;
